import { Form, Input } from 'antd';
import { getRules, getForm } from './util';

export const fieldTypeMap = {
    // 1-文本 2-下拉 3-数值 4-级联 5-日期 6 -上传 7-前端自定义类型 org_id  8-附件 10-关联字段
    TEXT: 1,
    SELECTED: 2,
    NUMBER: 3,
    CASCADE: 4,
    DATE: 5,
    UPLOAD: 6,
    SELECTEDTREE: 7,
    FILE: 8,
    SELECTED_EXT: 10
};
//form.item里面不能存在其他标签，所以用函数代替标签写法
const DynamicForm = (props) => {
    // 关联类型(field_type=10)：渲染隐藏的 _name 字段
    if (props.field_type === fieldTypeMap.SELECTED_EXT) {
        return (
            <>
                <Form.Item
                    key={props.field_id}
                    label={props.label === undefined ? props.name : props.label}
                    name={props.en_name}
                    rules={getRules(props)}
                >
                    {getForm(props)}
                </Form.Item>
                <Form.Item name={`${props.en_name}_name`} style={{ display: 'none' }}>
                    <Input />
                </Form.Item>
            </>
        );
    }
    return props.field_type === fieldTypeMap.DATE || props.field_type === fieldTypeMap.FILE || props.field_type === 4 || props.field_type === 3 ? (
        getForm(props)
    ) : (
        <Form.Item key={props.field_id} label={props.label === undefined ? props.name : props.label} name={props.en_name} rules={getRules(props)}>
            {getForm(props)}
        </Form.Item>
    );
};
export default DynamicForm;
